import ButtonSvg from "../../public/assets/svg/ButtonSvg"

const Button = ({ className, href, onClick, px, white, children }) => {
    const classes = `button relative inline-flex items-center justify-center h-11 transition-colors lg:hover:text-color-1 ${px || 'px-7'} ${className || ''}`

    const spanClasses = 'relative z-10'
    const renderButton = () => (
        <button className={classes} onClick={onClick}>
            <span className={spanClasses}>{children}</span>
            {ButtonSvg(white)}
        </button>
    )

    const renderLink = () => (
        <a href={href} className={classes}>
            <span className={spanClasses}>{children}</span>
            {ButtonSvg(white)}
        </a>
    )

    return href ? renderLink() : renderButton()
}

export default Button
